import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { startWith } from 'rxjs/operators';
import { TagsShowMoreComponent } from 'src/app/pages/buyer/company-search/modals/tags-show-more/tags-show-more.component';
import * as data from './data/data.json';

@Component({
  selector: 'search-filter-autocomplete-json',
  templateUrl: './search-filter-autocomplete-json.component.html',
  styleUrls: ['./search-filter-autocomplete-json.component.scss']
})
export class SearchFilterAutocompleteJsonComponent implements OnInit {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() items: string[] = [];
  @Input() searchField: string = 'JobSeniorities';
  @Input() iconName: string;
  @Input() expanded: boolean = false;

  @Output() itemsChange = new EventEmitter<string[]>();

  @ViewChild('auto') auto: ElementRef;
  @ViewChild('input') input: ElementRef;

  private jsonData: any = (data as any).default;

  addOnBlur = true;
  loading = false;
  inputControl = new FormControl();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredItems: string[] = [];

  constructor(private cdr: ChangeDetectorRef,public dialog: MatDialog,) {}

  ngOnInit() {
    this.setupFilteredItems();
  }

  private setupFilteredItems() {
    this.inputControl.valueChanges.pipe(
      startWith(''),
    ).subscribe(value => {
      this.filteredItems = this._filter(value);
      this.cdr.detectChanges();
    });
  }

  private getData(): string[] {
    if(this.searchField === 'JobSeniorities') {
      return this.jsonData?.JobSeniorities || [];
    }
    else if(this.searchField === 'JobFunctions') {
      return this.jsonData?.JobFunctions?.map(x=>x.name) || [];
    }
    else if(this.searchField === 'Industry') {
      return this.jsonData?.Industry?.map(x=>x.name) || [];
    }
    return [];
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    const selectedItems = this.items.map(item => item.toLowerCase());

    const availableItems = this.getData().filter(item => !selectedItems.includes(item.toLowerCase()));

    if (filterValue) {
      return availableItems.filter(item => item.toLowerCase().includes(filterValue)).slice(0, 7);
    } else {
      return availableItems.slice(0, 7);
    }
  }

  remove(item: string): void {
    const index = this.items.indexOf(item);
    if (index >= 0) {
      this.items.splice(index, 1);
      this.itemsChange.emit(this.items);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const value = event.option.value;
    if ((value || '').trim()) {
      this.items.push(value.trim());
      this.itemsChange.emit(this.items);
      this.inputControl.setValue('');
    }
  }

  tagsShowMore() {
    let data = {};
    if(this.searchField=="JobSeniorities"){
      data = {selectedLevels: this.items}
    }
    else if(this.searchField=="JobFunctions"){
      data = {selectedDepartments: this.items}
    }



    const dialogRef = this.dialog.open(TagsShowMoreComponent, {
      width: '500px',
      data: data,
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        if(this.searchField=="JobSeniorities"){
          this.items = data.selectedLevels;
        }
        if(this.searchField=="JobFunctions"){
          this.items = data.selectedDepartments;
        }



        this.itemsChange.emit(this.items);
        this.setupFilteredItems();
      }
    });
  }
}
